import { render, staticRenderFns } from "./CourseSideNav.vue?vue&type=template&id=c76c2c06&scoped=true&"
import script from "./CourseSideNav.vue?vue&type=script&lang=js&"
export * from "./CourseSideNav.vue?vue&type=script&lang=js&"
import style0 from "./CourseSideNav.vue?vue&type=style&index=0&id=c76c2c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76c2c06",
  null
  
)

export default component.exports